import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { registerLicense } from '@syncfusion/ej2-base';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

/*if (environment.production) {
  enableProdMode();
}*/

// Registering Syncfusion license key
registerLicense('ORg4AjUWIQA/Gnt2UlhhQlVMfV5AQmBIYVp/TGpJfl96cVxMZVVBJAtUQF1hTX9Td0BjXHxXcHVQT2ZZ');

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
